// Empty in dev uses CRA proxy (package.json → backend). Set REACT_APP_API_URL for production.
export const API_BASE = process.env.REACT_APP_API_URL || "";

export function apiUrl(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE}${normalized}`;
}
